function PivotColumnDimension(props) {
    return null;
}
PivotColumnDimension.symbol = 'PivotColumnDimension';

export { PivotColumnDimension as default };
